import { SvgIcon } from "@mui/material";
import styled from "styled-components";
import React from "react";
import { NavLink } from "react-router-dom";

const Link = styled(NavLink)`
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  padding: 0.5rem;
  &:hover {
    border-radius: 50%;
    background: #f0f0f0;
  }
`;

const MenuItem = ({ icon, text, path }) => {
  return (
    <Link to={path}>
      <SvgIcon component={icon} />
    </Link>
  );
};

export default MenuItem;
